export default __webpack_public_path__ + "static/media/callLogIcon.c3eee78c.svg";